import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'

export default class NewsletterAnchor extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = () => {
        const newsletter = document.getElementById('footerNewsletter')
        scrollToElement(newsletter)
    }
}